module.exports = __webpack_public_path__ + "img/case2-bg.5633aecf.png";